import React from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  IMdaePopupProps,
} from "../popup";
import MdaeButton from "../button";
import { TOGGLE_NOTIFY_POPUP } from "../../mdae-common-reducer";
import { useDispatch, useSelector } from "react-redux";
import { NOTIFY_POPUP_TYPES } from "./index";
import { isEqual } from "lodash";
import "./index.scss";
import $ from "jquery";

interface NotifyPopupProps extends IMdaePopupProps {
  widgetConfigPropertyName?: string;
  reducerName?: string;
  actionType?: string;
}

const NotifyPopup: React.FC<NotifyPopupProps> = (props) => {
  const dispatch = useDispatch();
  const widgetConfigPropertyName =
    props.widgetConfigPropertyName || "notifyPopupConfig";
  const widgetUpdaterReducerName = props.reducerName || "mdaeCommonReducer";
  const popupWidgetDataUpdaterConfig = props.mdaeDataUpdaterConfig || [
    {
      actionType: props.actionType || TOGGLE_NOTIFY_POPUP,
      reducerName: widgetUpdaterReducerName,
      widgetOptionBindings: {
        visible: widgetConfigPropertyName + ".visible",
        mdaePopupTitle: widgetConfigPropertyName + ".title",
        height: widgetConfigPropertyName + ".height",
        width: widgetConfigPropertyName + ".width",
      },
    },
  ];

  const notifyPopupConfig = useSelector(
    (state) =>
      state[popupWidgetDataUpdaterConfig[0].reducerName][
        widgetConfigPropertyName
      ],
    isEqual
  );
  const notifyPopupType =
    notifyPopupConfig?.notifyPopupType || NOTIFY_POPUP_TYPES.ALERT;
  const getDefaultNotifyConfig = () => {
    switch (notifyPopupType.toUpperCase()) {
      case NOTIFY_POPUP_TYPES.ALERT:
        return {
          messageIconClass: "fa fa-bell-o",
          messageIconColor: "black",
          title: "Alert",
        };
      case NOTIFY_POPUP_TYPES.WARNING:
        return {
          messageIconClass: "fa fa-warning",
          messageIconColor: "#ff7f50",
          title: "Warning",
        };
      case NOTIFY_POPUP_TYPES.INFO:
        return {
          messageIconClass: "fa fa-warning",
          messageIconColor: "black",
          title: "Information",
        };
      case NOTIFY_POPUP_TYPES.SUCCESS:
        return {
          messageIconClass: "fa fa-check-circle",
          messageIconColor: "green",
          title: "Success",
        };
      case NOTIFY_POPUP_TYPES.ERROR:
        return {
          messageIconClass: "fa fa-exclamation-triangle",
          messageIconColor: "red",
          title: "Error",
        };
      default:
        return {
          messageIconClass: "fa fa-bell-o",
          messageIconColor: "black",
          title: "Alert",
        };
    }
  };

  const notifyCloseHandler = () => {
    dispatch({
      type: popupWidgetDataUpdaterConfig[0].actionType,
      data: {
        visible: false,
      },
    });
  };
  const notifyPopupTitle = () => {
    return (
      <MdaePopupTitle
        isHideCloseButton={notifyPopupConfig?.isPopupShowCloseButton}
        isSmallPopup={notifyPopupConfig?.isSmallPopup}
        closePopupHandler={() => {
          notifyCloseHandler();
        }}
      >
        {notifyPopupConfig?.title || getDefaultNotifyConfig().title}
      </MdaePopupTitle>
    );
  };
  const notifyPopupContent = () => {
    return (
      <MdaePopupContent>
        <div
          className={
            notifyPopupConfig?.removePopupContentStyles
              ? ""
              : "notify-popup-content-container"
          }
        >
          {!notifyPopupConfig?.isHideNotifyTypeIcon && (
            <div>
              <i
                className={getDefaultNotifyConfig().messageIconClass}
                style={{
                  fontSize: "50px",
                  color: getDefaultNotifyConfig().messageIconColor,
                }}
              ></i>
            </div>
          )}
          <div
            className={
              notifyPopupConfig?.removePopupContentStyles
                ? ""
                : "mdae-standalone-label notify-popup-content-label"
            }
          >
            {typeof notifyPopupConfig?.contentHtml === "string"
              ? notifyPopupConfig?.contentHtml
              : null}
            {typeof notifyPopupConfig?.contentHtml === "function"
              ? notifyPopupConfig?.contentHtml()
              : null}
          </div>
        </div>
      </MdaePopupContent>
    );
  };
  const notifyPopupFooter = () => {
    return (
      <MdaePopupFooter>
        <MdaePopupFooterEndButtons>
          <MdaeButton
            id={""}
            role={"primary"}
            onClick={() => {
              notifyCloseHandler();
              if (
                typeof notifyPopupConfig?.notifyOkButtonHandler === "function"
              ) {
                notifyPopupConfig?.notifyOkButtonHandler();
              }
            }}
          >
            {notifyPopupConfig?.closeButtonText || "OK"}
          </MdaeButton>
        </MdaePopupFooterEndButtons>
      </MdaePopupFooter>
    );
  };
  return (
    <MdaePopup
      {...props}
      mdaeContentRender={notifyPopupContent}
      mdaeTitleRender={notifyPopupTitle}
      mdaeFooterRender={notifyPopupFooter}
      hideOnOutsideClick={false}
      maxHeight={600}
      autoHeight
      onShowing={(e) => {
        $(e.component.content())
          .children(".sys-mdae-popup-content-scroll-bar")
          .css("height", "100%");
        let isSmallPopup = false;
        if ($(e.component.content()).outerHeight(true) > 250) {
          isSmallPopup = false;
        } else {
          isSmallPopup = true;
        }
        dispatch({
          type: popupWidgetDataUpdaterConfig[0].actionType,
          data: {
            isSmallPopup: isSmallPopup,
          },
        });
      }}
      showTitle={true}
      mdaeDataUpdaterConfig={popupWidgetDataUpdaterConfig}
    ></MdaePopup>
  );
};

export default NotifyPopup;
